// extracted by css-extract-rspack-plugin
var _1 = "TP0EX2nGosp3Mgg8";
var _2 = "TkDQCloYU5wiS52H";
var _3 = "zHJDR0OHk3sPJpBB";
var _4 = "nNv9OGV37mQRIaQz";
var _5 = "ZPjQEYfdtfYL7I2e";
var _6 = "kFXEeYytRJM9mNbI";
export { _1 as "paginationLink", _2 as "paginationLinkActive", _3 as "paginationLinkDisabled", _4 as "paginationLinkSizeLg", _5 as "paginationLinkSizeMd", _6 as "paginationLinkSizeSm" }
// extracted by css-extract-rspack-plugin
var _1 = "TP0EX2nGosp3Mgg8";
var _2 = "TkDQCloYU5wiS52H";
var _3 = "zHJDR0OHk3sPJpBB";
var _4 = "nNv9OGV37mQRIaQz";
var _5 = "ZPjQEYfdtfYL7I2e";
var _6 = "kFXEeYytRJM9mNbI";
export { _1 as "paginationLink", _2 as "paginationLinkActive", _3 as "paginationLinkDisabled", _4 as "paginationLinkSizeLg", _5 as "paginationLinkSizeMd", _6 as "paginationLinkSizeSm" }
